import React from 'react';
import { motion } from 'framer-motion';

// UI Blocker Modal with Progress Indicator
const UIBlockerModal = ({ message, progressPercent, showGoToResults, onGoToResults }) => {
  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        initial={{ scale: 0.9, y: 20, opacity: 0 }}
        animate={{ scale: 1, y: 0, opacity: 1 }}
        exit={{ scale: 0.9, y: -20, opacity: 0 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="bg-white rounded-xl shadow-xl p-0 flex flex-col items-stretch min-w-[320px] max-w-2xl w-full max-h-[90vh]"
      >
        {/* Header (not scrollable) */}
        <div className="p-6 pb-0">
          <h2 className="text-xl font-bold text-center text-gray-900 mb-4">Rendering Data</h2>
        </div>
        {/* Scrollable Content */}
        <div className="flex-1 p-6 pt-0 overflow-y-auto min-h-0 no-scrollbar">
          {showGoToResults ? (
            <>
              <div className="flex justify-center items-center w-full mt-0 mb-2">
                <svg className="h-8 w-8 text-green-500 mt-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1" fill="white" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" d="M8.5 12.5l2.5 2.5 4.5-4.5" />
                </svg>
              </div>
            </>
          ) : (
            <>
              <img src="/logo.png" alt="Loading" className="h-12 w-12 mb-4 mx-auto animate-spin" />
              <div className="w-full mt-4 mb-2">
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-black transition-all duration-300"
                    style={{ width: `${progressPercent}%` }}
                  />
                </div>
                <div className="text-center text-xs text-gray-600 mt-1">{progressPercent}%</div>
              </div>
            </>
          )}
          <p className="text-sm text-gray-600 mb-4 text-center">{showGoToResults ? 'Your results are ready!' : 'Please wait while we analyze your connections.'}</p>
          <div className="flex flex-col items-center justify-center my-6">
            <div className="w-full max-w-2xl rounded-lg overflow-hidden shadow-lg border border-gray-200 bg-white">
              <div className="aspect-w-16 aspect-h-9 bg-black flex items-center justify-center">
                <video
                  src="/product-demo.mp4"
                  controls
                  autoPlay
                  muted
                  className="w-full h-80 md:h-96 bg-black object-cover"
                  style={{ border: 0 }}
                  poster="/product-demo-poster.png"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="p-3 text-center">
                <span className="text-sm text-gray-700 font-medium">See Quis in action: Watch our quick product demo!</span>
              </div>
            </div>
          </div>
        </div>
        {/* Footer (not scrollable) */}
        {showGoToResults && (
          <div className="flex justify-center p-4 border-t border-gray-100 bg-white rounded-b-xl">
            <button
              className="px-3 py-1 rounded-md bg-black text-white font-small text-base shadow hover:bg-gray-800 transition-all duration-150"
              onClick={onGoToResults}
            >
              Go to Results
            </button>
          </div>
        )}
      </motion.div>
    </motion.div>
  );
};

export default UIBlockerModal; 